(function() {
    'use strict';
    function MwListStatusExpansionPanelController($scope, $element, $translate, $sce, LIST_STATUS_FILTER_CONTACT_LIMIT) {
        var contentElement = $element.find('md-card-content'),
            expandIcon = $element.find('md-icon.expand-icon'),
            collapseIcon = $element.find('md-icon.collapse-icon');

        this.title = 'icm-search__list-status-filter--title';
        this.generalInfoTip = 'icm-search__list-status-filter--general-info-tip';

        this.$translate = $translate;
        this.$sce = $sce;

        this.$onInit = function () {
            this.toggle = function toggle() {
                $element.toggleClass('active');
                contentElement.toggle();
                expandIcon.toggle();
                collapseIcon.toggle();
            };


            this.selectedItemChange = function selectedItemChange(value) {
                this.selectionChanged({selectedItem: value});
            };

            this.optionSelected = function optionSelected(value) {
                return this.isSelected({option: value});
            };

            this.clickedClear = function clickedClear(e) {
                e.stopPropagation();

                if(this.clearSelection) {
                    this.clearSelection();
                }
            };

            // we set the contact count to -1 when we fail to retrieve the value. the only failure scenario we have run into thus far is that the company has too many contacts, and
            // the request fails. so that would mean they also have too many contacts to use this filter. disable it.
            this.isFilterDisabled = (((this.listContactCount >= LIST_STATUS_FILTER_CONTACT_LIMIT) || (this.listContactCount === -1)) ? true : false);
            this.isYesOptionDisabled = ((this.listContactCount <= 0) ? true : false);
        };
    }

    angular
        .module('MW.ContactManager.MwListStatusExpansionPanel', [])
        .component('mwListStatusExpansionPanel', {
            bindings: {
                clearSelection: '&',
                selectionChanged: '&',
                selectedOption: '<',
                listContactCount: '<'
            },
            controller: ['$scope', '$element', '$translate', '$sce', 'LIST_STATUS_FILTER_CONTACT_LIMIT', MwListStatusExpansionPanelController],
            template: `
                <md-card ng-class="{'isDisabled': $ctrl.isFilterDisabled}">
                    <md-card-title ng-click="$ctrl.toggle()">
                        <md-card-title-text layout="row">
                            <span flex>
                                <span class="panel-title" translate>{{$ctrl.title}}</span>
                                <mw-infotip class="title-infotip" text-content="{{$ctrl.generalInfoTip}}"></mw-infotip>
                                <span class="clear-selection pull-right" ng-if="$ctrl.selectedOption !== null" ng-click="$ctrl.clickedClear($event)" translate>icm-search__filter-clear</span>
                            </span>
                            <md-icon class="expand-icon" md-svg-icon="navigation:ic_expand_more_24px"></md-icon>
                            <md-icon class="collapse-icon" md-svg-icon="navigation:ic_expand_less_24px"></md-icon>
                        </md-card-title-text>
                    </md-card-title>
                    <md-card-content class="with-border">
                        <div class="radio-wrapper">
                            <md-radio-group ng-model="$ctrl.selectedOption" layout="column" class="md-primary">
                                <md-radio-button ng-disabled="$ctrl.isYesOptionDisabled || $ctrl.isFilterDisabled" class="radio-option" value="ON" ng-click="$ctrl.isYesOptionDisabled || $ctrl.isFilterDisabled || $ctrl.selectedItemChange('ON')">
                                    <span translate>Yes</span>
                                </md-radio-button>
                                <md-radio-button ng-disabled="$ctrl.isFilterDisabled" class="radio-option" value="OFF" ng-click="$ctrl.isFilterDisabled || $ctrl.selectedItemChange('OFF')">
                                    <span translate>No</span>
                                </md-radio-button>
                            </md-radio-group>
                        </div>
                    </md-card-content>
                </md-card>
            `
        });
}());
